import { textBoxRequiredControl } from '../../../../../constants/form-control/core/common/textbox/textbox-required';
import { FormControlUtil } from '../../../../../core/utils/form-control';

export const AddTaskGroupListActionControls = {
  task_group_name: FormControlUtil.mergeFormControl(textBoxRequiredControl, {
    key: 'task_group_name',
    templateOptions: FormControlUtil.mergeFormControl(textBoxRequiredControl.templateOptions, { label: 'Task Group Name' }),
  }),
  sub_task_name: FormControlUtil.mergeFormControl(textBoxRequiredControl, {
    key: 'sub_task_name',
    templateOptions: FormControlUtil.mergeFormControl(textBoxRequiredControl.templateOptions, { label: 'Sub Task Name' }),
  }),

};
